import { Component, Inject, Prop, Vue } from 'vue-property-decorator'
import { Validator } from 'vee-validate'
import { ConfigurationAssaygroupLaboratoryResponse } from '@/modules/configurationModule/detail/local-assays/assaygroups-laboratory/services/configuration-assaygroup-laboratory/configuration-assaygroup-laboratory.dto'
import { ConfigurationAssaygroupResponse } from '@/modules/configurationModule/detail/assays/configuration-assays-groups/services/configuration-assaygroup/configuration-assaygroup.dto'
import { configurationAssaygroupService } from '@/modules/configurationModule/detail/assays/configuration-assays-groups/services/configuration-assaygroup/configuration-assaygroup.service'
import { CommonParams } from '@/api/resources/common/shared/models/common.models'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

@Component
export default class ConfigurationLocalAssaysAssaygroupsLaboratoryModalBasicForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly assaygroupLaboratory!: Partial<ConfigurationAssaygroupLaboratoryResponse>

    @Inject() externalValidator!: Validator

    get updateMode(): boolean {
        return !!this.assaygroupLaboratory?.id
    }

    async getAssaygroups(): Promise<ConfigurationAssaygroupResponse[]> {
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response = await this.$_toCallUnique(configurationAssaygroupService.paginator(undefined, params))
        if (response) {
            return response.content
        }
        return []
    }

    constructor() {
        super()

        this.$validator = this.externalValidator
    }
}
